var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('EpbPill',{attrs:{"color":_vm.state.color,"size":"small","type":"solid-dark"}},[_vm._v("\n    "+_vm._s(_vm.state.message)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }